var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDecreaseRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 26,
    viewBox: "0 0 76 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M76 26L64.5026 24.9311L71.1769 15.5085L76 26ZM33.8479 5.5564L33.2945 4.72348L33.8479 5.5564ZM27.2237 9.95745L26.6703 9.12453L27.2237 9.95745ZM1.56921 0.177809L14.3217 9.00649L13.1833 10.6509L0.43079 1.82219L1.56921 0.177809ZM26.6703 9.12453L33.2945 4.72348L34.4013 6.38933L27.7771 10.7904L26.6703 9.12453ZM48.0028 4.94317L69.2338 19.9818L68.0778 21.6139L46.8467 6.57522L48.0028 4.94317ZM33.2945 4.72348C37.7713 1.74915 43.6168 1.83646 48.0028 4.94317L46.8467 6.57522C43.1355 3.94647 38.1893 3.87259 34.4013 6.38933L33.2945 4.72348ZM14.3217 9.00649C18.0255 11.5706 22.9182 11.6174 26.6703 9.12453L27.7771 10.7904C23.3428 13.7365 17.5605 13.6812 13.1833 10.6509L14.3217 9.00649Z",
    fill: "#F09581"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDecreaseRed);
export default __webpack_public_path__ + "static/media/decrease-red.7013bb1c02a5463baee84ac76cc03162.svg";
export { ForwardRef as ReactComponent };